import React from 'react';
import SubscribeForm from 'components/Form/SubscribeForm';
import { EmailContainer } from './styles';

const EmailCapture = ({ classNames, ...otherProps }) => {
  return (
    <EmailContainer id="sidebar-email-capture" className={classNames}>
      <SubscribeForm
        className="sidebar--subscribe-marketo-form"
        shouldRedirect={false}
        formType="Email Capture | Sidebar"
        dataPosition="sidebar email capture"
        buttonType="secondary"
        revealProps={{
          styles: 'sidebar--subscribe-marketo-legal-info',
        }}
        {...otherProps}
      />
    </EmailContainer>
  );
};

export default EmailCapture;
